module.exports = __webpack_public_path__ + "static/media/icon-help.1c0e0d85.svg";